import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router, UrlSerializer } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { fromEvent } from "rxjs/observable/fromEvent";
import { map, takeUntil } from "rxjs/operators";
import { ICheckStatus } from "../../../../shared/services/auth/recuperar-senha/recuperar-senha.interface";
import { RecuperarSenhaService } from "../../../../shared/services/auth/recuperar-senha/recuperar-senha.service";
import swal from "sweetalert2";

@Component({
    selector: 'app-email-confirmation',
    templateUrl: './email-confirmation.component.html',
    styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent {
    public email: string = '';
    private unsubscriber = new Subject();
    public form: FormGroup = new FormGroup({
        one: new FormControl(null, Validators.required),
        two: new FormControl(null, Validators.required),
        tree: new FormControl(null, Validators.required),
        four: new FormControl(null, Validators.required),
        five: new FormControl(null, Validators.required),
        six: new FormControl(null, Validators.required),
    });
    
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private recuperarSenhaService: RecuperarSenhaService,
        private urlSerializer: UrlSerializer) {

        this.route.queryParams.subscribe(params => {
            if (params['token']) {
                const revertBase64 = atob(params['token']);
                const revertJSON = JSON.parse(revertBase64)
                this.email = revertJSON.Email;

                this.recuperarSenhaService.checkStatus(this.email)
                .pipe(takeUntil(this.unsubscriber))
                .subscribe((response: ICheckStatus) => {
                    if (response && !response.EmailConfirmed && revertJSON.Code) {
                        this.confirmEmail(this.email, revertJSON.Code);
                    }
                })
            }
        });
        
        fromEvent(document, 'paste')
        .pipe(takeUntil(this.unsubscriber))
        .subscribe((event: any) => {
            event.preventDefault();
            event.stopPropagation();
            const pastedText = event.clipboardData.getData('text');
            const array = pastedText.split('');
            this.form.patchValue({
            'one': array[0],
            'two': array[1],
            'tree': array[2],
            'four': array[3],
            'five': array[4],
            'six': array[5],
            })
        });
    }

    public confirmEmail(email: string, code: string): void {
        const base64 = btoa(JSON.stringify({Email: email, Code: code}));
        this.recuperarSenhaService.confirmEmail({Email: email, Code: code})
        .pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
            if (response) {
                swal('Email confirmado com sucesso!');
                const tree = this.router.createUrlTree(['/login/register-password'], {
                    queryParams: { token: base64 },
                    queryParamsHandling: 'merge',
                });
                const url = this.urlSerializer.serialize(tree);
                this.router.navigateByUrl(url);
            }
        }, (error) => {
            console.error(error);
            swal('Ocorreu um erro.');
        });
    }

    public resendEmail(): void {
        this.recuperarSenhaService.sendEmailResetPassword(this.email)
        .pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
            if (response) {
                swal('Email enviado com sucesso!');
            }
        }, (error) => {
            console.error(error);
            swal('Ocorreu um erro.');
        });
    }

    public submit(form, value): void {
        if (form.invalid) return;

        const { one, two, tree, four, five, six } = value;
        const code =  `${one + two + tree + four + five + six}`;

        this.resetPassword(this.email, code);
    }

    resetPassword(email, code): void {
        const base64 = btoa(JSON.stringify({Email: email, Code: code}));
        this.recuperarSenhaService.checkResetPassowrd({ Email: email, Code: code})
        .pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
            if (response) {
                swal('Código verificado com sucesso!');
                const tree = this.router.createUrlTree(['/login/register-password'], {
                    queryParams: { token: base64 },
                    queryParamsHandling: 'merge',
                });
                const url = this.urlSerializer.serialize(tree);
                this.router.navigateByUrl(url);
            }
        }, (error) => {
            console.error(error);
            const defaultError = 'Ocorreu um erro.';

            if (error 
                && error.error 
                & error.error.ValidationResult
                && error.error.ValidationResult.Errors 
                && error.error.ValidationResult.Errors[0]
                && error.error.ValidationResult.Errors[0].ErrorMessage) {
                return swal(error.error.ValidationResult.Errors[0].ErrorMessage);
            }

            return swal(defaultError);
        });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/auth/components/email-confirmation/email-confirmation.component.ts